export const FETCH_CATEGORY = 'FETCH_CATEGORY'
export const FETCH_CATEGORY_FAILED = 'FETCH_CATEGORY_FAILED'
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS'